import styled from 'styled-components'

import { Button as ButtonBase } from '@icontainers/design-system/dist/molecules/Button'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Button = styled(ButtonBase)`
    margin-top: 30px;
    width: 100%;

    button {
        width: 100%;

        & > span:first-child {
            ${(props) => props.theme.typo.bodyM};
            ${(props) => props.theme.fontWeight.medium};
            text-decoration: none;
        }
    }

    @media ${(props) => props.theme.query.min.tablet} {
        margin-top: 0px;
    }
`

export const Link = styled(LinkBase)`
    width: 100%;
    max-width: 364px;

    @media ${(props) => props.theme.query.mobile} {
        width: 100%;

        & > div {
            display: block;

            button {
                width: 100%;

                span:first-child {
                    margin: 0px;
                }
            }
        }
    }
`
